const endPoint = {
  login: "login",
  getOtp: "get-otp",
  editPassword: "edit-password",

  classes: "classes",
  matieres: "matieres",
  periodes: "periodes",
  chapitres: "chapitres",
  matiereClasse: "matiere-de-la-classe",

  lecons: "lecons",
  evaluations_lecons: "evaluations-lecons",
  res_lecons_eleves:"res-lecons-eleves",
  questions_lecons: "questions-lecons",
  questions_lecons_import: "questions-lecons-import",
  questions_import: "questions-import",
  evaluations: "evaluations",
  questions: "questions",
  parametres:"parametres",
  messagesDefilants:"messages-defilants",
  meets:"meets",


  cours: "cours",
  files: "files",
  files_evaluation_lecon: "files-evaluation-lecon",

  roles:"roles",
  permissions:"permissions",
  users: "users",
  utilisateurs: "utilisateurs",

  fournisseurs: "fournisseurs",
  clients: "clients",
  administrateurs: "administrateurs",

  // Endpoints pour les abonnements
  subscriptionPlans: "subscription-plans",
  subscriptions: "subscriptions",
  paymentTransactions: "payment-transactions",
  subscriptionAnalytics: "subscription-analytics",
  
  // Endpoints spécifiques pour les formules
  subscriptionPlansPricing: "subscription-plans", // Pour le calcul de prix /{slug}/pricing
};

export default endPoint;
